(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-configurator-button"] && !Shopify.designMode) return;
  try {
    class ConfiguratorButton extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a[ref="link"]');
      this.rootUrl = this.dataset.rootUrl;
      this.separator = this.dataset.separator;

      try {
        this.variantMap = JSON.parse(
          this.querySelector('script[type="application/json"]').textContent
        );
      } catch (e) {
        this.variantMap = {};
      }

      // Observe URL changes (Horizon uses history.replaceState on variant change)
      this.lastUrl = location.href;
      this.urlObserver = setInterval(() => {
        if (location.href !== this.lastUrl) {
          this.lastUrl = location.href;
          this.updateFromUrl();
        }
      }, 200);
    }

    disconnectedCallback() {
      clearInterval(this.urlObserver);
    }

    updateFromUrl() {
      const params = new URLSearchParams(location.search);
      const variantId = params.get('variant');
      if (variantId) {
        this.updateLink(variantId);
      }
    }

    updateLink(variantId) {
      const configuratorParams = this.variantMap[variantId];
      if (configuratorParams) {
        this.link.href = this.rootUrl + this.separator + configuratorParams;
        this.link.style.display = '';
      } else {
        this.link.style.display = 'none';
      }
    }
  }

  if (!customElements.get('configurator-button')) {
    customElements.define('configurator-button', ConfiguratorButton);
  }
  } catch(e) { console.error(e); }
})();

})();
